// extracted by mini-css-extract-plugin
export default {"heading":"ManageDevices_heading__OguAs","wrapper":"ManageDevices_wrapper__-8o1n"};